var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20H20",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.0001V20.5001C8.13261 20.5001 8.25979 20.4474 8.35355 20.3536L8 20.0001ZM4 20.0001H3.5C3.5 20.2762 3.72386 20.5001 4 20.5001V20.0001ZM4 16.0001L3.64645 15.6465C3.55268 15.7403 3.5 15.8675 3.5 16.0001H4ZM15.2929 4.7072L15.6464 5.06075V5.06075L15.2929 4.7072ZM16.7071 4.7072L16.3536 5.06075V5.06075L16.7071 4.7072ZM19.2929 7.29299L19.6464 6.93943V6.93943L19.2929 7.29299ZM19.2929 8.7072L18.9393 8.35365L19.2929 8.7072ZM8 19.5001H4V20.5001H8V19.5001ZM4.5 20.0001V16.0001H3.5V20.0001H4.5ZM4.35355 16.3536L15.6464 5.06075L14.9393 4.35365L3.64645 15.6465L4.35355 16.3536ZM16.3536 5.06075L18.9393 7.64654L19.6464 6.93943L17.0607 4.35365L16.3536 5.06075ZM18.9393 8.35365L7.64645 19.6465L8.35355 20.3536L19.6464 9.06075L18.9393 8.35365ZM18.9393 7.64654C19.1346 7.8418 19.1346 8.15838 18.9393 8.35365L19.6464 9.06075C20.2322 8.47497 20.2322 7.52522 19.6464 6.93943L18.9393 7.64654ZM15.6464 5.06075C15.8417 4.86549 16.1583 4.86549 16.3536 5.06075L17.0607 4.35365C16.4749 3.76786 15.5251 3.76786 14.9393 4.35365L15.6464 5.06075Z",
    fill: "#2F2F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.f61002d2.svg";
export { ForwardRef as ReactComponent };